import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/blog7.jpg";
import { Link } from "react-router-dom";
import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";
const Ecommerce: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
                Intelligent e-commerce solutions that boost revenue and loyalty.
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
              At our AI SaaS and data solutions company, we design AI-driven tools specifically for e-commerce businesses. By analyzing customer behavior, purchase patterns, and browsing data, our solutions provide personalized recommendations, predictive insights, and automated optimizations that improve the shopping experience.
              </p>

              <p className="mt-20">
               We collaborate with retailers to tailor AI systems that fit their product catalog, sales goals, and customer journey. Whether it’s improving conversion rates, optimizing inventory, or enhancing user engagement, our AI for e-commerce solutions ensure measurable impact and scalable growth.
              </p>
              {/* VIDEO EMBED */}
              <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
             <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/byQ8GudNBu8?si=tdTbBYTBUOQL4WgA" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Personalized Recommendations.</span></li>
                    <li><span className="iconlist_text">Predictive Analytics.</span></li>
                    <li><span className="iconlist_text">Dynamic Pricing Optimization.</span></li>
                    <li><span className="iconlist_text">Customer Segmentation.</span></li>
                    <li><span className="iconlist_text">Automated Marketing Campaigns.</span></li>
                    <li><span className="iconlist_text">Real-Time Insights.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-20 mt-60">
               Turning E-Commerce Data Into Smart Decisions
              </h3>

              <p className="mb-40">
               AI-powered e-commerce systems go beyond simple analytics. They predict what customers are likely to buy, suggest the best promotions, and optimize pricing dynamically. By leveraging real-time data, online retailers can respond instantly to trends, stock levels, and customer preferences.<br></br>
              From personalized product recommendations to automated marketing campaigns and inventory forecasting, AI empowers e-commerce businesses to provide seamless, efficient, and highly relevant shopping experiences.
              </p>
              

              {/* IMAGE + LIST */}
             

              <h3 className="item_details_info_heading mb-25">3 Ways AI for E-Commerce Transforms Businesses</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Increase Sales and Conversions.</span></li>
                <li><span className="iconlist_text">2. Optimize Operations.</span></li>
                <li><span className="iconlist_text">3. Enhance Customer Experience.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default Ecommerce;
